// define global variables for ESLint
/* global bar_product_single_page_config */

const localstorage = require("../../modules/language_and_default_ship_to/language_and_ship_to_switcher");

jQuery(document).ready(function ($) {
  //move color selection (ux-swatches) outside of td element, because safari does not like it after "add to cart" action^^
  var label_div = $(".variations_form .ux-swatches").closest("tr").find("label");
  var custom_color_div = $('<div class="color_selection_container"></div>');
  custom_color_div.append(label_div);
  custom_color_div.append($(".variations_form .ux-swatches"));
  $(".custom_attribute_selection_section").append(custom_color_div);
  $(".variations_form .ux-swatches .ux-swatch").on("click", function (e) {
    var selected_val = $(this).data("value");
    if ($(this).hasClass("selected")) {
      selected_val = "";
    }
    $("#pa_color").val(selected_val).change();
  });

  $(document).on("click", ".btn", function () {
    var container = $(this).closest(".bundled_product");
    if (container.length <= 0) {
      container = $(this).closest(".variations_form");
    }

    container.find(".btn").removeClass("on");
    $(this).addClass("on");

    var actual_input_id = $(this).data("attribute-name");
    container.find('option[value="' + $(this).attr("value") + '"]').each(function () {
      $(this).prop("selected", true);
    });
    container.find('select[data-attribute_name="attribute_' + actual_input_id + '"]').trigger("change");
    //    $("#" + actual_input_id).trigger("change");
  });

  //be sure that mini cart is not visible on page load
  $(".cart-item.has-dropdown.current-dropdown").removeClass("current-dropdown");
  setTimeout(function () {
    $(".cart-item.has-dropdown.current-dropdown").removeClass("current-dropdown");
  }, 10);
  setTimeout(function () {
    $(".cart-item.has-dropdown.current-dropdown").removeClass("current-dropdown");
  }, 100);

  $(".single_variation_wrap").on("show_variation", function (event, variation) {
    if ($(".bundle_form").length > 0) {
      return; //dont show final-variation-info-wrapper for bundle products
    }
    let price_container = $(".product-price-container");
    price_container.addClass("has_final_price");
    price_container.find(".final-variation-info-wrapper").remove();
    let shipping_day_info_block = "";
    let current_shipping_country_is_eu = localstorage.getLocalStorage("bar_country_is_eu");

    let is_backorder_allowed_without_availability = false;
    if (variation.availability_html === "" && variation.backorders_allowed) {
      is_backorder_allowed_without_availability = true;
    }
    if (variation.shipping_info_for_all_customers) {
      shipping_day_info_block =
        "<span class='shipping-info-for-all'> - " + variation.shipping_info_for_all_customers + "</span>";
    } else if (
      variation.shipping_info_for_eu_customer &&
      current_shipping_country_is_eu &&
      current_shipping_country_is_eu === "yes" &&
      !is_backorder_allowed_without_availability
    ) {
      shipping_day_info_block =
        "<span class='shipping-day-info-eu'> - " + variation.shipping_info_for_eu_customer + "</span>";
    }
    price_container.append(
      "<div class='final-variation-info-wrapper'><div class='final-variation-price'>" +
        variation.price_html +
        "</div><div class='final-variation-availability'>" +
        variation.availability_html +
        shipping_day_info_block +
        "</div></p>"
    );
  });

  $(".variations_form").on("woocommerce_variation_select_change", function () {
    $(".product-price-container").removeClass("has_final_price");
  });

  $(".bundle_data").on("woocommerce-product-bundle-validation-status-changed", function (event, bundle) {
    if (bundle.api.get_bundle_validation_status() === "pass") {
      $(".product-price-container").addClass("has_final_price");
      $(".bundle_price").addClass("has_final_price");
    } else {
      $(".product-price-container").removeClass("has_final_price");
      $(".bundle_price").removeClass("has_final_price");
    }
  });

  $(".bundle_data").on("woocommerce-product-bundle-initialized", function (event, bundle) {
    bundle.showing_price_html = true; //always show bundle price => because we hide the product price container in case all variants are selected.
  });

  //in case of simple product append shipping_info_for_eu_customer after page load
  var current_selected_country_is_in_eu = localstorage.getLocalStorage("bar_country_is_eu");
  if (current_selected_country_is_in_eu && current_selected_country_is_in_eu === "yes") {
    $(".shipping-day-info-eu").removeClass("hidden");
  }

  $("body").on("click touchend", ".single_add_to_cart_button_pseudo", function (e) {
    var container = $(this).closest(".single_add_to_cart_button_container");
    container.find(".error-message").remove();
    var message = bar_product_single_page_config.i18_attribute_not_selected_default_message;
    if ($(".final-variation-availability .stock.out-of-stock").length > 0) {
      message = "";
    }

    var not_selected_attributes = [];
    for (let i = 0; i < bar_product_single_page_config.product_attributes.length; i++) {
      var attribute_id = bar_product_single_page_config.product_attributes[i].product_attribute_id;
      var attribute_description = bar_product_single_page_config.product_attributes[i].i18_attribute_description;
      if ($("#" + attribute_id).val() === "") {
        not_selected_attributes.push(attribute_description);
      }
    }
    if (not_selected_attributes.length > 0) {
      message = bar_product_single_page_config.i18_attribute_not_selected_message;
      var first_attributes = not_selected_attributes.slice(0, not_selected_attributes.length - 1);
      var last_attribute = not_selected_attributes.slice(
        not_selected_attributes.length - 1,
        not_selected_attributes.length
      );

      var attribute_string = "";
      if (first_attributes.length > 0) {
        attribute_string += first_attributes.join(", ") + " " + bar_product_single_page_config.i18_and;
      }
      attribute_string += " " + last_attribute;
      message = message.replace("%s", attribute_string);
    }

    container.prepend("<div class='error-message'>" + message + "</div>");
  });

  $("body").on("click touchend", ".buttons_instead_of_select_container .btn, .ux-swatch", function (e) {
    $(".single_add_to_cart_button_container .error-message").remove();
  });
});
